import axios from "axios";
import { createContext, useContext, useEffect, useMemo, useState } from "react";

// const AuthContext = createContext();

const AuthProvider = () => {
  // State to hold the authentication token
  const [token, setToken_] = useState(localStorage.getItem("auth_token"));

  // Function to set the authentication token
  const setToken = (newToken) => {
    setToken_(newToken);
  };

  useEffect(() => {
    if (token) {
      axios.defaults.headers.common["Authorization"] = "Bearer " + token;
      localStorage.setItem("auth_token", token);
    } else {
      delete axios.defaults.headers.common["Authorization"];
      localStorage.removeItem("auth_token");
    }
  }, [token]);

  const contextValue = useMemo(
    () => ({
      token,
      setToken,
    }),
    [token]
  );

  return contextValue;
};
// export { contextValue };
export default AuthProvider;
